export default class Sequence {
  static get TALKN_PROTOCOL() {
    return 'talkn:';
  }
  static get HTTP_PROTOCOL() {
    return 'http:';
  }
  static get HTTPS_PROTOCOL() {
    return 'https:';
  }
  static get WSS_PROTOCOL() {
    return 'wss:';
  }
  static get UNKNOWN_PROTOCOL() {
    return '????:';
  }
  static get EMIT_ME_KEY() {
    return '@EMIT_ME';
  }
  static get API_SEPARATE_IO_TYPE_START() {
    return '[';
  }
  static get API_SEPARATE_IO_TYPE_END() {
    return ']';
  }
  static get API_REQUEST_TYPE() {
    return 'REQUEST';
  }
  static get API_RESPONSE_TYPE_EMIT() {
    return 'EMIT';
  }
  static get API_RESPONSE_TYPE_BROADCAST() {
    return 'BROADCAST';
  }
  static get API_SETUP() {
    return 'API_SETUP';
  }
  static get UNKNOWN() {
    return 'UNKNOWN';
  }
  static get CONNECTION_SERVER_KEY() {
    return 'CONNECTION_SERVER';
  }
  static get API_TO_SERVER_REQUEST() {
    return `API_TO_SERVER[${Sequence.API_REQUEST_TYPE}]${Sequence.METHOD_COLON}`;
  }
  static get SERVER_TO_API_EMIT() {
    return `SERVER_TO_API[${Sequence.API_RESPONSE_TYPE_EMIT}]${Sequence.METHOD_COLON}`;
  }
  static get SERVER_TO_API_BROADCAST() {
    return `SERVER_TO_API[${Sequence.API_RESPONSE_TYPE_BROADCAST}]${Sequence.METHOD_COLON}`;
  }
  static get API_TO_CLIENT_REQUEST() {
    return `API_TO_CLIENT[${Sequence.API_REQUEST_TYPE}]${Sequence.METHOD_COLON}`;
  }
  static get API_TO_CLIENT_EMIT() {
    return `API_TO_CLIENT[${Sequence.API_RESPONSE_TYPE_EMIT}]${Sequence.METHOD_COLON}`;
  }
  static get API_TO_CLIENT_BROADCAST() {
    return `API_TO_CLIENT[${Sequence.API_RESPONSE_TYPE_BROADCAST}]${Sequence.METHOD_COLON}`;
  }
  static get API_BROADCAST_CALLBACK() {
    return 'tune';
  }
  static get REDUX_ACTION_KEY() {
    return 'type';
  }
  static get METHOD_COLON() {
    return ':';
  }
  static get ADD_CLIENT_ACTION_PREFIX() {
    return 'API_TO_CLIENT';
  }
  /**
   * Endpoint map — documents the current request/response contract.
   * Keys match ch-server endpoint names registered in endpoints/index.ts.
   */
  static get map() {
    return {
      tune: {
        responseEmitState: { tuneCh: '*', rank: '*', rankAll: '*', posts: '*', sessionId: '*' },
        responseBroadcastState: { tuneCh: '*', rank: '*', rankAll: '*' },
      },
      untune: {
        responseEmitState: { tuneCh: '*', rank: '*', rankAll: '*' },
        responseBroadcastState: { tuneCh: '*' },
      },
      fetchPosts: {
        responseEmitState: { posts: '*' },
        responseBroadcastState: {},
      },
      fetchRank: {
        responseEmitState: { rank: '*' },
        responseBroadcastState: {},
      },
      fetchChDetail: {
        responseEmitState: { tuneCh: '*' },
        responseBroadcastState: {},
      },
      digCh: {
        responseEmitState: { digChs: '*', errors: '*' },
        responseBroadcastState: {},
      },
      discoverCh: {
        responseEmitState: { digChs: '*', errors: '*' },
        responseBroadcastState: {},
      },
      subscribeDiscoveredChs: {
        responseEmitState: { digChs: '*', errors: '*' },
        responseBroadcastState: {},
      },
      post: {
        responseEmitState: { success: '*' },
        responseBroadcastState: { posts: '*' },
      },
      trackSession: {
        responseEmitState: { success: '*', saved: '*', errors: '*' },
        responseBroadcastState: {},
      },
      disconnect: {
        responseEmitState: {},
        responseBroadcastState: { tuneCh: '*' },
      },
      typing: {
        responseEmitState: {},
        responseBroadcastState: { typingUsers: '*' },
      },
    };
  }

}
